import { ConditionValueSetPicker } from "./condition-value-set-picker"

const UNITS = ["Nr", "System", "Not Specified"]

export function ConditionValueUnitOfMeasure({ value, onChange }) {
    return (
        <ConditionValueSetPicker
            value={value}
            onChange={onChange}
            options={UNITS}
            placeholder="Select units of measure..."
            freeSolo
        />
    )
}
